let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1JJNK")).then(() => parcelRequire('dbol2'));